import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin, Card, Typography as AntdTypography } from "antd";
import LeftArrow from "Assets/Icons/LeftArrow";
import { StyledMainDiv } from "Pages/DeveloperTools/DeveloperToolsMain";
import { MainPageDiv } from "utilFunctions/shared/StyledComponent/StyledComponent";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { UserInfoContext } from "Context/CommonContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  DEVELOPER_COMMON_CONFIG,
} from "utilFunctions/Constants/urlConstants";
import DRSCustomConfigTable, { DRSConfig } from "./DRSCustomConfigTable";

const { Title } = AntdTypography;

const DRSCustomConfig = () => {
  const userInfo = useContext<any>(UserInfoContext);
  const navigate = useNavigate();
  const { screen }: any = useWindowSize();
  const [configs, setConfigs] = useState<Record<string, DRSConfig[]>>({});

  const { makeRequest: GetConfigs, loading: pageLoading } = useGetApi(
    (response: any) => {
      if (response && response.data) {
        setConfigs(response.data);
      }
    },
    (error: any) => {
      console.log("error fetching configurations", error);
    }
  );

  const fetchConfigs = () => {
    const url = BASE_URL + DEVELOPER_COMMON_CONFIG;
    console.log(url);
    GetConfigs(url);
  };

  useEffect(() => {
    if (userInfo.employeeId) {
      fetchConfigs();
    }
  }, [userInfo]);

  const handleUpdate = (group: string, updatedGroupConfigs: DRSConfig[]) => {
    setConfigs((prev) => ({
      ...prev,
      [group]: updatedGroupConfigs,
    }));
  };

  if (pageLoading) {
    return <Spin fullscreen></Spin>;
  }

  return (
    <MainPageDiv screen={screen}>
      <StyledMainDiv
        screen={screen}
        style={{ justifyContent: "space-between" }}
      >
        <div className="d-flex align-items-center">
          <LeftArrow
            className={"cursorHoverCSS mr-1"}
            onClick={() => {
              navigate("/admin/dashboard", {
                replace: true,
                state: {
                  selectedStudent: null,
                },
              });
            }}
          />

          <Title level={4} style={{ margin: 0 }}>
            Custom Config
          </Title>
        </div>
      </StyledMainDiv>
      <div>
        {Object.keys(configs).length > 0
          ? Object.entries(configs).map(([groupName, groupConfigs]) => (
              <Card
                key={groupName}
                title={
                  <Title level={5} style={{ margin: 0 }}>
                    {groupName.replace(/_/g, " ")}
                  </Title>
                }
                style={{ marginBottom: "20px" }}
                bordered={false}
              >
                <DRSCustomConfigTable
                  groupName={groupName}
                  configs={groupConfigs}
                  setConfigs={handleUpdate}
                />
              </Card>
            ))
          : !pageLoading && <Card>No configuration data available.</Card>}
      </div>
    </MainPageDiv>
  );
};

export default DRSCustomConfig;
